export default __webpack_public_path__ + "static/media/preAppIllustrationDark.3cd941fb.png";